import { Navigation } from "swiper/modules";
import CustomIcon from "@/components/ui/custom-icon";
import { useDetailActualData } from "../../../hooks/useDetailActualData";
import { Swiper, SwiperSlide } from "swiper/react";
import Ss from "./index.module.scss";
import Image from "next/image";
import clsx from "clsx";

const DetailActualGallery = () => {
  const { detailActual, isLoading } = useDetailActualData();

  if (!detailActual || isLoading) return null;

  return (
    <div className={Ss.gallery}>
      <Swiper
        slidesPerView={3}
        modules={[Navigation]}
        breakpoints={{
          0: {
            slidesPerView: 2,
            spaceBetween: 8,
          },
          1280: {
            slidesPerView: 3,
            spaceBetween: 40,
          },
        }}
        navigation={{
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }}
      >
        {detailActual.slider?.map((item, idx) => (
          <SwiperSlide key={idx}>
            <Image className={Ss.galleryImage} width={660} height={660} src={item} alt="gallery" />
          </SwiperSlide>
        ))}
        <div className={clsx("swiper-button-prev", Ss.customNavArrow, Ss["customNavArrow--back"])}>
          <CustomIcon fileName={"chevron-right"} />
        </div>
        <div className={clsx("swiper-button-next", Ss.customNavArrow)}>
          <CustomIcon fileName={"chevron-right"} />
        </div>
      </Swiper>
    </div>
  );
};

export default DetailActualGallery;
